/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type MetricsFiltersGated = (typeof MetricsFiltersGated)[keyof typeof MetricsFiltersGated];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MetricsFiltersGated = {
  gated: 'gated',
  ungated: 'ungated',
} as const;
